import useWatchTime from 'src/hooks/useWatchTime';
import useSeek from 'src/hooks/useSeek';
import useUI from 'src/hooks/useUI';
import SeekBar from 'src/themes/cosmos/components/SeekBar';
import TextTime from 'src/themes/cosmos/components/TextTime';
import SettingsButton from 'src/themes/cosmos/components/SettingsButton';
import FullScreenControl from 'src/themes/cosmos/components/FullScreenControl';
import { IconSize } from 'src/interfaces/Icon';
import useApplicationData from 'src/hooks/useApplicationData';
import { ComponentsName, TRANSMISSION_TYPE } from 'src/interfaces/enums';
import { UserEventTriggerType } from 'src/interfaces/Datahub';
import { WrapComponentVisibility } from 'src/themes/shared/containers/WrapComponentVisibility';
import LiveControl from '../../components/LiveControl';
import styles from './styles.module.scss';

const BottomBarMobile = () => {
  const {
    bufferIndicatorPercent,
    timePercent,
    setWatchTime,
    currentTime,
    duration,
    isCloseToLiveEdge,
    seekToLiveEdge,
  } = useWatchTime();

  const { toggleFullscreen, fullscreen, toggleSettings } = useUI();
  const { transmissionType } = useApplicationData();
  const { onSeekInit, onSeekEnded } = useSeek();

  const isLive = transmissionType === TRANSMISSION_TYPE.live;

  return (
    <div className={styles.bottomBar} data-testid='bottom-bar'>
      {!isLive && (
        <WrapComponentVisibility componentName={ComponentsName.seekBar}>
          <div className={styles.seekbar}>
            <SeekBar
              onSeeking={setWatchTime}
              bufferIndicatorPercent={bufferIndicatorPercent}
              currentPercent={timePercent}
              onSeekInit={onSeekInit}
              onSeekEnded={onSeekEnded}
            />
          </div>
        </WrapComponentVisibility>
      )}
      <div className={styles.controls}>
        <div className={styles.columns}>
          {isLive ? (
            <LiveControl active={isCloseToLiveEdge} onClick={seekToLiveEdge} />
          ) : (
            <>
              <TextTime time={currentTime} />
              <TextTime time={duration - currentTime} />
            </>
          )}
        </div>
        <div className={styles.columns}>
          <SettingsButton iconSize={IconSize.small} onClick={toggleSettings} />
          <FullScreenControl
            iconSize={IconSize.small}
            active={fullscreen}
            onClick={() => toggleFullscreen(UserEventTriggerType.CLICK)}
          />
        </div>
      </div>
    </div>
  );
};

export default BottomBarMobile;
